<template>
  <div>
    <modal
      :open="open"
      :title="trans('attendance_list.contexts.' + contextLabel)"
      style="text-align:left; "
      @close="closeModal"
    >
      <form>
        <div
          class="form-group"
          style="text-align:left;"
        >
          <p>{{ studentName }}</p>
          <p>
            {{ trans('attendance_list.minutes_late_explanation', { 'contextLabel': trans('attendance_list.contexts.' + contextLabel) }) }}
          </p>
          <br>
          <input
            v-model="time"
            prefix-icon=""
            type="time"
            class="form-control"
            :class="{ 'has-error' : error != null }"
          >
          <p
            v-if="error != null"
            class="has-error__validation-text"
          >
            {{ error }}
          </p>
        </div>
      </form>

      <br>

      <button
        type="button"
        class="btn btn-success pull-right"
        @click="addContext"
      >
        {{ trans('core.save') }}
      </button>
      <button
        v-if="minutes != null"
        type="button"
        class="btn btn-danger pull-right"
        @click="deleteContext"
      >
        {{ trans('core.delete_object', { object: trans_choice('core.contexts', 1) }) }}
      </button>
      <br style="clear: both">
    </modal>
  </div>
</template>

<script>

import toast from '@/services/toast'
import Modal from './Modal.vue'
import { defaultErrorMessage } from '@/helpers'
import { TimePicker } from 'element-ui'
import locale from 'element-ui/lib/locale'

const lang = require(`element-ui/lib/locale/lang/${Lang.locale}`).default
locale.use(lang)

export default {

  name: 'AttendanceListMinutesModals',

  components: { Modal, TimePicker },

  props: {
    courseId: {
      required: true,
      type: String,
    },
    lessonId: {
      required: true,
      type: String,
    },
    studentId: {
      required: true,
      type: String,
    },
    contextLabel: {
      required: true,
      type: String,
    },
    minutes: {
      required: false,
      default: null,
    },
  },

  data () {
    return {
      open: false,
      open_remark: null,
      remark_choice: null,
      time: null,
      error: null,
    }
  },

  computed: {
    studentName () {
      return this.$store.state.attendancelist.students[this.studentId].attributes.name
    },

    minutesMissingEnd () {
      return this.$store.state.attendancelist.minutesMissingConfig.context_minutes_from_end
    },

    lesson () {
      return this.$store.state.attendancelist.lesson
    },
    minutesEnd () {
      return this.minutesMissingEnd != null && Object.values(this.minutesMissingEnd).some(context => context === this.contextLabel)
    },
  },

  watch: {},

  mounted () {
    if (this.minutes != null) {
      let time = 0
      if (!this.minutesEnd) {
        time = this.lesson.starttime + parseInt(this.minutes) * 60
      } else {
        time = this.lesson.endtime - parseInt(this.minutes) * 60
      }
      this.time = moment.unix(time).format('HH:mm')
    } else if (moment().unix() < this.lesson.starttime) {
      this.time = moment.unix(this.lesson.starttime).format('HH:mm')
    } else if (moment().unix() > this.lesson.endtime) {
      this.time = moment.unix(this.lesson.endtime).format('HH:mm')
    } else {
      this.time = moment().format('HH:mm')
    }

    this.openModal()
  },

  methods: {
    openModal () {
      this.open = true
    },

    closeModal () {
      this.open_remark = null
      this.open = false
      this.$emit('closed-modal')
    },

    addContext () {
      this.error = null

      // We calculate the timestamp based on date event and time
      const day = moment.unix(this.lesson.starttime).format('YYYY-MM-DD')
      const timestamp = moment(day + this.time, 'YYYY-MM-DD HH:mm').unix()

      // Check if the time is within lesson times
      if (timestamp >= this.lesson.endtime || timestamp <= this.lesson.starttime) {
        this.error = Lang.get('attendance_list.minutes_late_not_in_time')
        return
      }

      let minutes = 0

      // If minutes end we calculate time from end
      if (this.minutesEnd) {
        minutes = Math.round((this.lesson.endtime - timestamp) / 60)
      } else {
        minutes = Math.round((timestamp - this.lesson.starttime) / 60)
      }

      // Final check if minutes is not 0 or negative
      if (minutes <= 0) {
        this.error = Lang.get('attendance_list.minutes_late_not_in_time')
        return
      }

      // store the content
      this.$store.dispatch('change_loading', { loading: true }).then(() => {
        return this.$store.dispatch('change_context', {
          courseId: this.courseId,
          lessonId: this.lessonId,
          studentId: this.studentId,
          contextType: this.contextLabel,
          checked: false,
          remark: minutes,
        }).then(() => {
          this.closeModal()
          return toast.success(Lang.get('attendance_list.context_saved'))
        }).catch(error => defaultErrorMessage(error))
      }).then(() => {
        this.$store.dispatch('change_loading', { loading: false })
      })
    },

    deleteContext () {
      this.$store.dispatch('change_loading', { loading: true }).then(() => {
        return this.$store.dispatch('change_context', {
          courseId: this.courseId,
          lessonId: this.lessonId,
          studentId: this.studentId,
          contextType: this.contextLabel,
          checked: true,
        }).then(() => {
          this.closeModal()
          return toast.success(Lang.get('attendance_list.context_deleted'))
        }).catch(error => defaultErrorMessage(error))
      }).then(() => {
        this.$store.dispatch('change_loading', { loading: false })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.has-error {
  border-color: #d50000;

  &__validation-text {
    color: #d50000;
    font-size: 14px;
  }
}
.btn {
  margin-left: 10px;
}
</style>
